import { render } from "./TagPage.vue?vue&type=template&id=18bc1119&scoped=true&ts=true"
import script from "./TagPage.vue?vue&type=script&lang=ts"
export * from "./TagPage.vue?vue&type=script&lang=ts"

import "./TagPage.vue?vue&type=style&index=0&id=18bc1119&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bc1119"]])

export default __exports__